import {Component, computed, inject, Input, signal} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap/modal';
import {NotificationService} from '../../../../../Services/NotificationService';
import {RestClient} from '../../../../../Api/DcoApi/Client/RestClient';
import {Kooperationspartner} from '../../../../../Api/DcoApi/Kooperationspartner';
import {Lauf} from '../../../../../Api/DcoApi/Abrechnung/Lauf';
import {CommonModule} from '@angular/common';
import {Splash} from '../../../../../Akte/Controlls/Splash';
import {FormsModule} from '@angular/forms';
@Component({
  selector: 'app-generating-popup',
  imports: [
    CommonModule,
    Splash,
    FormsModule
  ],
  standalone: true,
  templateUrl: './generating-popup.html',
  styleUrl: './generating-popup.css',
})
export class GeneratingPopup {
  @Input() Partner: number[] | null = null;
  modal = inject(NgbActiveModal);
  ApiClient:RestClient = new RestClient();

  private NotificationService = inject(NotificationService);

  Monate: number = 6;
  currentDate = new Date();
  currentMonth = this.currentDate.getMonth() + 1;
  currentYear = this.currentDate.getFullYear();

  AnzahlEintraege = signal<number>(0);
  AktuellerEintrag = signal<number>(0);
  CalculationMonth = signal<number>(0);
  CalculationYear = signal<number>(0);
  CalculationPartnerId = signal<number>(0);
  PartnerList = signal<Kooperationspartner[]>( []);
  Lauf = signal<Lauf[]>([]);
  CalculationPartner = computed(() => this.PartnerList().find(x => x.key == this.CalculationPartnerId()));
  CalculatePercentage = computed(() => this.AktuellerEintrag() / this.AnzahlEintraege() * 100);

  IsCalculating = signal<boolean>(false);
  ShowErrorInfo = signal<boolean>(false);
  CanClose = signal<boolean>(false);
  Success = signal<boolean>(false);
  constructor() {
    this.GetPartner();
  }

  async GetPartner()
  {
      this.PartnerList.set(await this.ApiClient.Get<Kooperationspartner[]>('/Backend/Api/V2/Kooperationspartner'));
  }

  async CreateNewInvoice()
  {

    var client = await this.NotificationService.RunFunction<any>("/AbrechnungData/StartNewInvoice/",null, (i) => {
      if(!this.IsCalculating())
        this.IsCalculating.set(true);

      switch(i.eventType)
      {
        case 'CalculatePartner':

          var partner = JSON.parse(i.eventData) as IPartnerEvent;
          this.CalculationPartnerId.set(partner.partnerID);
          break;
        case 'CalculateMonth':
          var Month = JSON.parse(i.eventData) as IMonthEvent;
          this.CalculationMonth.set(Month.month);
          this.CalculationYear.set(Month.year);
          break;
        case 'CalculateEntry':
          var calc = JSON.parse(i.eventData) as IEntryEvent;
          this.CalculationMonth.set(calc.month);
          this.CalculationYear.set(calc.year);
          this.AnzahlEintraege.set(calc.sum);
          this.AktuellerEintrag.set(calc.currentEntry);
          break;
        case 'Error':
          this.ShowErrorInfo.set(true);
          break;
        case 'FinishCalculation':
          var finish = JSON.parse(i.eventData) as IFinishEvent;
          this.Lauf.set(finish.items);
          this.IsCalculating.set(false);
          this.CanClose.set(true);
          this.Success.set(true);
          client?.stop()
          break;
        case 'Faild':
          this.ShowErrorInfo.set(true);
          this.IsCalculating.set(false);
          this.CanClose.set(true);
          client?.stop()
          break;
      }

    });


  }

}


interface IPartnerEvent{
  partnerID: number;
}

interface IEntryEvent{
  month: number;
  year: number;
  sum: number;
  currentEntry: number;
}

interface IMonthEvent{
  month: number;
  year: number;
}

interface IFinishEvent{
  items: Lauf[];
}
